import qs from 'qs'

const fields = [
  'title',
  'slug',
  'locale',
  'secondaryTitle',
  'sortKeyAsc',
  'sortKeyDesc'
]

const populate = {
  eventCategories: true,
  dateTimeRanges: true
}

export const queryEventEntryBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: fields,
      populate: {
        ...populate,
        ...queryFragmentSeo,
        ...queryFragmentBlocks,
        ...queryFragmentExhibitionEntries,
        ...queryFragmentEducationEntries,
        ...queryFragmentProjectEntries,
        ...queryFragmentJournalEntries,
        linkTopPage: queryFragmentLink,
        coverImage: '*',
        localizations: {
          fields: fields
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `event-entries?${query}`
}
